// Ícone SVG inline da bandeira American Express (sem requisição HTTP)
import * as React from 'react';

export function AmexIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="American Express" {...props}>
      <rect width="48" height="32" rx="4" fill="#1F72CD" />
      <text
        x="24"
        y="14"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="800"
        fontSize="5"
        fill="#fff"
        letterSpacing="0.4"
      >
        AMERICAN
      </text>
      <text
        x="24"
        y="22"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="800"
        fontSize="5"
        fill="#fff"
        letterSpacing="0.4"
      >
        EXPRESS
      </text>
    </svg>
  );
}
